import type { BuildingDataWidgetSections } from "../../../types/buildings-sections/building-data-widget";

export const buildingDataWidget: BuildingDataWidgetSections = {
  pageSubtitle: "Review, confirm, and edit this building's attribute values",
  buildingDataHistory: "Building data history",
  backToHistory: "Back to building data history",
  closeHistory: "Close building data history",
  resizeHistoryPanel: "Resize building data history panel",
  searchFields: "Search fields…",
  loading: "Loading…",
  dataLoadError: "Couldn't load building data",
  retryData: "Retry",
  noFieldsMatch: 'No fields match "{query}"',
  noFieldsYet: "No fields to display yet",
  updatedAgo: "Updated · {time}",
  updatedNever: "Updated · —",
  pendingGroupHint: "Unconfirmed findings in this group",
  addValue: "Add value",
  optionsCount: "{count} options",
  editedBy: "Edited by",
  confirmedBy: "Confirmed by",
  unknownUser: "unknown",
  confirmValue: "Confirm",
  confirmThisValue: "Confirm this value",
  rejectEdit: "Reject / edit",
  dismiss: "Dismiss",
  typeNewValue: "Type a new value…",
  saveTypedValue: "Save typed value",
  editValue: "Edit",
  saveError: "Couldn't save",
  missingUserProfile: "User profile missing",
  cannotOpenDocument: "Cannot open document",
  selectAnOption: "Select an option",
  selectMultiple: "Select one or more",
  noOptions: "No options available",
  extremeValueTitle: "This looks like an unusual value",
  extremeValueBody:
    "The value you entered looks extreme for this attribute. Are you sure you want to save it?",
  extremeValueSaveAnyway: "Save anyway",
  extremeValueEdit: "Edit",
  done: "Done",
  cancel: "Cancel",
  clearValue: "Clear value",
  filterAll: "All",
  filterEmpty: "Empty",
  filterPending: "Pending",
  noFieldsForFilter: "No fields match this filter",
  acceptNewValue: "Accept new value",
  keepCurrentValue: "Keep current value",
  previousValueLabel: "Previous",
  proposedValueLabel: "New finding",
  currentValueLabel: "Current",
  viewHistory: "View value history",
  valueHistory: "Value history",
  supportingSources: "Supporting sources",
  noHistory: "No history recorded yet",
  loadingHistory: "Loading history…",
  historyLoadError: "Couldn't load history",
  retryHistory: "Retry",
  sourceEhr: "EHR registry",
  sourceExtractor: "Document extraction",
  sourceIfc: "BIM model",
  franklinFindings: "Franklin findings",
  statusConfirmed: "Confirmed",
  statusNeedsReview: "Needs review",
  statusNewFinding: "New finding",
  statusMissing: "Missing",
  actionSaved: "Building data updated",
  actionUndone: "Change undone",
  undoAction: "Undo",
  rejectValue: "Reject value",
  showMore: "Show more",
  showLess: "Show less",
  confirmAll: "Confirm all {count}",
  sections: "Sections",
  collapseSections: "Collapse sections",
  expandSections: "Expand sections",
  allFields: "All fields",
  closeInspector: "Close inspector",
  resizeInspector: "Resize panel",
  confidence: "Confidence",
  confidenceHigh: "High",
  confidenceMedium: "Medium",
  confidenceLow: "Low",
  completionPercent: "{percent}% complete",
  valueLabel: "Value",
  save: "Save",
  sourceEvidence: "Source evidence",
  otherMentions: "Other mentions ({count})",
  pageLabel: "Page",
  loadingEvidence: "Loading source passage…",
  evidenceLoadError: "The source passage could not be loaded.",
  retryEvidence: "Retry",
  history: "History",
  reject: "Reject",
  accept: "Accept",
  reviewQueue: "Building data review queue",
  reviewProgress: "Review {current} of {total}",
  exitReview: "Exit review",
  valueAccepted: "Value accepted",
  valueRejected: "Value rejected and cleared to Missing",
  proposedValue: "Proposed value",
  alternateCandidates: "Other candidates",
  noAlternateCandidates: "No alternate candidates found",
  previous: "Previous",
  skip: "Skip",
  reviewFields: "Review {count} fields",
  seeHistory: "See history",
  sectionConfirmed: "Confirmed {count} values",
  sectionConfirmPartial: "Confirmed {confirmed} of {total} values. Failed values were unchanged.",
  sectionConfirmValidationBlocked:
    "Confirmed {confirmed} values. {invalid} unusual values were left for individual review.",
};
